import { ArrowPathIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useOutdatedCheck } from "./useOutdatedCheck";

export function OutdatedBanner() {
  const { showBanner, dismiss } = useOutdatedCheck();

  if (!showBanner) return null;

  return (
    <div className="border-b border-accent/30 bg-accent/10 text-accent-fg">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2.5 text-sm">
        <ArrowPathIcon className="hidden size-5 shrink-0 sm:block" />
        <p className="flex-1">
          <span className="font-semibold">Fresh off the press!</span> We just shipped some
          updates. Hit refresh to grab the latest goodies.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="shrink-0 rounded-md bg-accent px-3 py-1 text-xs font-medium text-white transition-colors hover:bg-accent/80"
        >
          Refresh
        </button>
        <button
          type="button"
          onClick={dismiss}
          className="shrink-0 rounded-md p-1 transition-colors hover:bg-accent/20"
          aria-label="Dismiss update notice"
        >
          <XMarkIcon className="size-4" />
        </button>
      </div>
    </div>
  );
}
